import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box } from 'reflexbox';
import Loader from 'react-loading';
import If from 'frontend/components/If';

import config from 'frontend/config';

class RaidbotsLoader extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.func,
    description: PropTypes.string,
    delay: PropTypes.number,
    size: PropTypes.number,
    color: PropTypes.string,
  };

  static defaultProps = {
    loading: true,
    loaded: () => null,
    description: null,
    delay: 300,
    size: 20,
    color: config.colors.green,
  };

  state = {
    show: false,
  }

  componentDidMount() {
    const { delay } = this.props;
    if (delay) {
      this.timeout = setTimeout(() => this.setState({ show: true }), delay);
    } else {
      this.setState({ show: true });
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { loading, description, loaded, delay, size, color, ...props } = this.props;
    return (
      <If
        condition={loading}
        then={() => (
          <If
            condition={this.state.show}
            then={() => (
              <Flex {...props} align="center">
                <Box>
                  <Loader
                    type="spin"
                    color={color}
                    height={size}
                    width={size}
                    delay={0}
                  />
                </Box>
                <If
                  condition={description}
                  then={() => (
                    <Box ml={1}>
                      {description}
                    </Box>
                  )}
                />
              </Flex>
            )}
          />
        )}
        else={loaded}
      />
    );
  }
}

export default RaidbotsLoader;
